import { Stack } from '@mui/material';
import * as React from 'react';
import styled from 'styled-components';
import { usePrevious } from '../../shared/hook/hook';

export interface IMapProps {
    onClick: (coordinate: ICoordinate) => void;
    coordinates: ICoordinate;
}

export interface ICoordinate {
    latitude?: number | string;
    longitude?: number | string;
}

const defaultCoordinate: ICoordinate = {
    latitude: 41.9,
    longitude: 12.49,
};

const MapContainer = styled(Stack)`
    padding: 0;
    height: 15.5rem;
`;

let map: any;
let layer: any;
let leaflet = (window as any).L;

const Map = (props: IMapProps) => {
    const divMap = React.useRef(null);
    const prevCoordinates = usePrevious(props.coordinates);
    const setMarker = (coordinates: ICoordinate) => {
        if (layer != undefined) {
            layer.remove();
        }
        layer = leaflet.marker([coordinates.latitude!, coordinates.longitude!]).addTo(map);
        props.onClick(coordinates);
    };

    const createMap = () => {
        map = leaflet.map(divMap.current!);
        leaflet
            .tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            })
            .addTo(map);
    };

    const setView = (coordinates: ICoordinate) => map.setView([coordinates.latitude!, coordinates.longitude!], 8);

    React.useEffect(() => {
        createMap();
        map.on('click', (e: any) => setMarker({ latitude: parseFloat(e.latlng.lat.toFixed(4)), longitude: parseFloat(e.latlng.lng.toFixed(4)) }));
    }, []);

    React.useEffect(() => {
        if (JSON.stringify(prevCoordinates) !== JSON.stringify(props.coordinates)) {
            if (props.coordinates.latitude && props.coordinates.longitude) {
                setView(props.coordinates);
                setMarker(props.coordinates);
            } else {
                setView(defaultCoordinate);
            }
        }
    }, [props.coordinates]);

    return <MapContainer ref={divMap} />;
};

export default Map;
